import { Sprout, Scale, BadgeCheck, Package, Plane, Timer } from "lucide-react";
import { BENEFITS } from "@/lib/vgt";
import { Reveal, SectionHeader } from "./Reveal";

const ICONS = { Sprout, Scale, BadgeCheck, Package, Plane, Timer };

export const WhyChoose = () => (
  <section id="why-vgt" data-testid="why-choose-section" className="py-20 sm:py-28 px-4 sm:px-8 bg-[#F5EFE6]">
    <div className="max-w-7xl mx-auto">
      <SectionHeader
        eyebrow="02 · Why Choose VGT"
        title="An Indonesian Supplier Built for Buyers Abroad"
        sub="Everything an international B2B buyer needs from a vanilla beans exporter in Indonesia — and nothing inflated."
      />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {BENEFITS.map((b, i) => {
          const Icon = ICONS[b.icon];
          return (
            <Reveal key={b.title} delay={i * 0.06}>
              <div
                data-testid={`benefit-tile-${i}`}
                className="group h-full bg-[#FDFBF7] border border-[#E6DEC3] rounded-3xl p-7 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-xl"
              >
                <span className="inline-flex w-12 h-12 rounded-2xl bg-[#EAF0EC] text-[#2E4F3E] items-center justify-center transition-colors duration-500 group-hover:bg-[#2E4F3E] group-hover:text-[#FDFBF7]">
                  <Icon size={21} />
                </span>
                <h3 className="mt-5 font-serif font-bold text-lg text-[#2C1A0C]">{b.title}</h3>
                <p className="mt-2.5 text-sm text-[#6E5B4F] leading-relaxed">{b.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
